/**
 * 用户端  专利检索
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <cusNav></cusNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top">
            <div v-if="searchNav == 'search'" class="eval-con-title"><span style="font-weight: 700;">丨</span>专利检索</div>
            <div v-if="searchNav == 'result'" class="eval-con-title">
                <span style="font-weight: 700;">丨</span><span style="cursor: pointer;" title="返回专利检索" @click="jumpSearch()">专利检索</span>
                <span> > </span><span>检索结果</span>
            </div>
         </div>
         <!-- 专利检索界面 -->
         <div v-if="searchNav == 'search'" class="search_page">
            <el-form :model="searchForm" class="eval-form" label-width="120px" >
                <div class="my_card">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="申请号" class="required-label" prop="applyNumber" style="padding: 0 25px;">
                                <el-input size="small"  v-model.trim="searchForm.applyNumber" auto-complete="off" placeholder="例：CN202411438730.X" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="申请日" class="required-label" prop="applyDate" style="padding: 0 25px;">
                                <el-input size="small"  v-model.trim="searchForm.applyDate" auto-complete="off" placeholder="例：20241015" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="申请(专利权)人" class="required-label" prop="applicant" style="padding: 0 25px;">
                                <el-input size="small"  v-model.trim="searchForm.applicant" auto-complete="off" placeholder="例：四川大学" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="专利状态" class="required-label" prop="status" style="padding: 0 25px;">
                                 <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 390px;">
                                    <el-option v-for="item in statusSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                 </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="公开(公告)号" class="required-label" prop="pubNumber" style="padding: 0 25px;">
                                <el-input size="small"  v-model.trim="searchForm.pubNumber" auto-complete="off" placeholder="例：CN119322993B" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="公开(公告)日" class="required-label" prop="pubDate" style="padding: 0 25px;">
                                <el-input size="small"  v-model.trim="searchForm.pubDate" auto-complete="off" placeholder="例：20250805" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="发明(设计)人" class="required-label" prop="inventor" style="padding: 0 25px;">
                                <el-input size="small"  v-model.trim="searchForm.inventor" auto-complete="off" placeholder="例：张瀚" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="专利类型" class="required-label" prop="type" style="padding: 0 25px;">
                                <el-select v-model="searchForm.type" placeholder="请选择" clearable style="width: 390px;">
                                    <el-option v-for="item in typeSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                 </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div class="my_btnBox">
                <div class="btn" @click="clearSearch()">清空</div>
                <div class="btn cat" @click="commitSearch()">检索</div>
            </div>
         </div>
         <!-- 检索结果界面 -->
         <div v-if="searchNav == 'result'" class="result_page">
            <div class="headTab" v-loading="false">
                <div class="number" style="display: flex; align-items: center;">
                  <!-- 全选复选框 -->
                  <el-checkbox v-model="checkAll" @change="handleCheckAllChange" style="margin-right: 15px;" title="全选当前页所有数据">全选</el-checkbox>
                    检索结果（条）：<span>{{ pageparm.total }}</span>
                </div>
                <div style="margin-right: 30px;">
                    <el-button size="small" style="background-color: #2A91DD;color: #ffffff;" title="勾选进行批量价值评估" @click="checkCreateEvalOrder()">价值评估</el-button>
                </div>
            </div>
            <div class="result_list">
                <div v-for="(item,i) in patentData" class="result_card" :key="i" :class="{'bgFFFFFF':i%2!=0,'bgF3F9FC':i%2===0}">
                    <div>
                        <div style="display: flex;">
                           <el-checkbox v-model="item.checked" style="margin-right: 12px;margin-left: -18px;margin-top: 1px;" @click=""></el-checkbox>
                           <div style="margin-left: -10px;margin-top: 2px;font-size: 14px;">{{ i+1 }}. </div>
                            <!-- <div>{{ item.title }}</div> -->
                            <div v-html="item.title"></div>
                            <div style="margin-left: 10px;align-items: center;">
                                <div class="pat_type">{{ item.type }}</div>
                            </div>
                            <div v-if="item.is_pay" class="eval_btn" title="点击查看专利价值评估报告" @click="viewReport(item)">查看报告</div>
                            <div v-else class="eval_btn" title="点击进行专利价值评估" @click="createEvalorder(item)">价值评估</div>
                        </div>
                        <div class="card_div">
                            <div class="card_text"><span>专利公开号：</span>{{ item.pubNumber[0] }}</div>
                            <div class="card_text"><span>公开时间：</span>{{ item.pubDate }}</div>
                            <div class="card_text"><span>主分类号：</span>{{ item.mainIpc }}</div>
                            <div class="card_text"><span>专利状态：</span>{{ item.status }}</div>
                        </div>
                        <div class="card_div">
                            <div class="card_text"><span>专利申请号：</span>{{ item.appNumber[0] }}</div>
                            <div class="card_text"><span>申请时间：</span>{{ item.appDate }}</div>
                            <div class="card_text" :title="item.applicant"><span>申 请 人 ：</span>{{ item.applicant }}</div>
                            <div class="card_text" :title="item.patentee"><span>专利权人：</span>{{ item.patentee }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin: 0px 10px;border-top: 2px solid #eeeeee;">
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </div>
         </div>
         <!-- 订单确认弹窗(单件) -->
         <el-dialog :close-on-click-modal="false" :visible.sync="orderConfirmVisible" width="770px">
            <div style="margin-top: -30px;">
               <div style="display: flex;align-items: center;">
               <img style="width: 60px;height: 60px;margin-right: 20px;" src="../../assets/eval/pay_head.png">
               <div style="height: 60px;display: flex;flex-direction: column;">
                  <div style="font-weight: 700;font-size: 18px;color: #333;line-height: 30px;margin-bottom: 10px;text-align: left;">支付界面</div>
                  <div style="font-size: 14px;color: #999;line-height: 20px;">请完善您的订单信息</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>订单详情</div>
            </div>
            <div class="pay_order">
               <div class="pay_order_th">
                  <div style="width: 142px;">项目</div>
                  <div style="flex: 1;">专利公告号</div>
                  <div style="width: 66px;text-align: right;">金额</div>
               </div>
               <div class="pay_order_tr">
                  <div style="text-align: center;width: 142px;">专利价值评估</div>
                  <div style="flex: 1;">{{ orderForm.documentNumber }}</div>
                  <div style="width: 66px;text-align: right;">{{ unitPrice }}</div>
               </div>
               <div class="order_count">
                  <div style="font-size: 14px;">合计</div>
                  <div style="font-size: 16px;color: #ff4242;">￥{{ unitPrice }}</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>支付方式</div>
            </div>
            <div class="pay_type_box">
               <div class="pay_type_item">
                  <el-checkbox v-model="orderForm.pay_type" :true-label="2" :false-label="0" style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_zhifubao.png">支付宝支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_item">
                  <el-checkbox v-model="orderForm.pay_type" :true-label="1" :false-label="0" disabled style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_weixi.png">微信支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_jf">
                  积分余额：{{ userPoints }}
               </div>
               <el-checkbox v-model="orderForm.is_use_points" :true-label="2" :false-label="1">优先使用积分</el-checkbox>
            </div>
            <div class="pay_btn">
               <el-button style="color: #fff;background-color: #2A91DD;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="commitReportOrder()">前往支付</el-button>
            </div>
            </div>
         </el-dialog>
         <!-- 订单确认弹窗(批量) -->
         <el-dialog :close-on-click-modal="false" :visible.sync="ordersConfirmVisible" width="770px">
            <div style="margin-top: -30px;">
               <div style="display: flex;align-items: center;">
               <img style="width: 60px;height: 60px;margin-right: 20px;" src="../../assets/eval/pay_head.png">
               <div style="height: 60px;display: flex;flex-direction: column;">
                  <div style="font-weight: 700;font-size: 18px;color: #333;line-height: 30px;margin-bottom: 10px;text-align: left;">支付界面</div>
                  <div style="font-size: 14px;color: #999;line-height: 20px;">请完善您的订单信息</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>订单详情</div>
            </div>
            <div class="pay_order">
               <div class="pay_order_th">
                  <div style="width: 142px;">项目</div>
                  <div style="flex: 1;">专利公告号</div>
                  <div style="width: 66px;text-align: right;">金额</div>
               </div>
               <div style="max-height: 260px;overflow-y: auto;">
                  <div class="pay_order_tr" v-for="(item,i) in ordersForm.documentNumbers">
                      <div style="text-align: center;width: 142px;">{{ i+1 }}. 专利价值评估</div>
                      <div style="flex: 1;">{{ item }}</div>
                      <div style="width: 66px;text-align: right;">{{ unitPrice }}</div>
                  </div>
                </div>
               <div class="order_count">
                  <div style="font-size: 14px;">合计</div>
                  <div style="font-size: 16px;color: #ff4242;">￥{{ ordersForm.total_fee }}</div>
               </div>
            </div>
            <div class="pay_title">
               <div class="pay_title_bg"></div>
               <div>支付方式</div>
            </div>
            <div class="pay_type_box">
               <div class="pay_type_item">
                  <el-checkbox v-model="ordersForm.pay_type" :true-label="2" :false-label="0" style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_zhifubao.png">支付宝支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_item">
                  <el-checkbox v-model="ordersForm.pay_type" :true-label="1" :false-label="0" disabled style="width: 187px;padding: 0 20px;align-items: center;height: 50px;justify-content: space-between;line-height: 50px;">
                     <div class="type_item-right" style="font-size: 14px;margin-left: 10px;">
                        <img style="width: 14px;margin-right: 4px;" src="../../assets/eval/pay_weixi.png">微信支付
                     </div>
                  </el-checkbox>
               </div>
               <div class="pay_type_jf">
                  积分余额：{{ userPoints }}
               </div>
               <el-checkbox v-model="ordersForm.is_use_points" :true-label="2" :false-label="1">优先使用积分</el-checkbox>
            </div>
            <div class="pay_btn">
               <el-button style="color: #fff;background-color: #2A91DD;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="commitReportOrders()">前往支付</el-button>
            </div>
            </div>
         </el-dialog>
         <!-- 积分支付确认 -->
      <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="pointsPayConfirmVisible" width="400px">
         <div class="pay_price" style="height: 300px">
            <div style="font-size: 16px;color: #333;font-weight: 700;margin-top: -10px;">订单支付</div>
            <div style="margin-top: 10px;margin-bottom: 20px;">积分全额抵扣</div>
            <div>消耗积分</div>
            <!-- <div>{{ orderResult.points }}</div> -->
            <div style="color: #ff2c2c;font-size: 16px;margin-top: 4px;">{{ orderResult.deduction_fee }}</div>
            <div style="margin-top: 20px;">抵扣金额</div>
            <!-- <div>￥{{ orderResult.deduction_fee }}</div> -->
            <div style="color: #b9b9b9;text-decoration: line-through;margin-top: 4px;">￥{{ orderResult.deduction_fee }}</div>
            <div class="pay_btn">
               <el-button style="color: #fff;background-color: #008D9D;padding: 10px 20px;border-radius: 4px;cursor: pointer;" @click="orderPayUsePoints()">积分支付</el-button>
            </div>
         </div>
      </el-dialog>
      <!-- 扫码支付 -->
      <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="codePayConfirmVisible" width="400px">
         <div class="pay_price">
            <div style="font-size: 16px;color: #333;font-weight: 700;margin-top: -10px;">订单支付</div>
            <div style="margin-top: 10px;margin-bottom: 20px;">请使用支付宝扫码支付</div>
            <img :src="orderResult.pay_code" style="width: 150px;height: 150px;margin-bottom: 40px;" />
            <div v-if="orderResult.deduction_fee > 0" style="color: #999999;margin-bottom: 20px;">
               <span>积分抵扣：</span>
               <span>￥{{ orderResult.deduction_fee }}</span>
            </div>
            <div style="margin-bottom: 20px;">
               <span>实际支付：</span>
               <span style="color: #ff2c2c;font-size: 16px;">￥{{ orderResult.total_fee }}</span>
            </div>
         </div>
      </el-dialog>

      </div>
    </div>
 </template>
 <script>
   import topInfo from '../../components/topInfo'
   import cusNav from '../../components/cusNav'
   import '../../assets/js/directive'
   import { 
    searchPatent,
    getOrderConfig,
    getUserInfo,
    createReportOrderByOne,
    createReportOrderByMore,
    orderPayByPoints,
    getEvalOrderInfo
   } from '../../api/evalMG'
   import { checkLogin } from '../../utils/util'
   import Pagination from '../../components/Pagination'
import { Loading } from 'element-ui'
   export default {
      data() {
         return {
            loading: false,
            checkAll: false,
            orderConfirmVisible: false,
            ordersConfirmVisible: false,
            codePayConfirmVisible: false,
            pointsPayConfirmVisible: false,
            title: '',
            searchNav: '',
            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            searchForm: {
                applicant: '',
                applyNumber: '',
                pubNumber: '',
                inventor: '',
                applyDate: '',
                pubDate: '',
                type: '',
                status: '',
                page: 1,
                ps: 10
            },
            statusSelect: [
                    {label: '有效',value:'10'},
                    {label: '无效',value:'20'},
                    {label: '在审',value:'30'}
                ],
            typeSelect: [
                {label:'发明专利',value:'1'},
                {label:'实用新型',value:'2'},
                {label:'外观设计',value:'3'},
            ],
            patentData: [],
            
            unitPrice: 0,// 评估单价
            userPoints: 0,// 用户积分
            orderForm: {
               total_fee: 0,
               is_use_points: 0,
               pay_type: 0,
               documentNumber: ''
            },
            ordersForm: {
              total_fee: 0,
               is_use_points: 0,
               pay_type: 0,
               documentNumbers: []
            },
            // 定时器
            intervalId: null,
            // 订单结果数据
            orderResult: [],
            
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }  
    }
      },
      computed: {
        // 判断是否所有条目的 checked 都为 true
          isAllChecked() {
              return this.patentData.every(item => item.checked);
          }
      },
       // 注册组件
      components: {
         Pagination,
         topInfo,
         cusNav
      },
      created(){
        this.searchNav = 'search'
        // this.searchNav = 'result'
      },
      // 监听
      watch: {
         // 监听 patentData 中 checked 的变化，更新全选状态
        patentData: {
            handler() {
                if (this.patentData.length === 0) {
                    this.checkAll = false;
                } else {
                    this.checkAll = this.patentData.every(item => item.checked);
                }
            },
            deep: true
        },
        codePayConfirmVisible(val){
            if(val){
               console.log(val)
               this.startTimer()
            }
            if(!val){
               console.log(val)
               this.stopTimer()
            }
         }
      },
      mounted(){

      },
      methods: {
        // 清空检索条件
        clearSearch(){
            this.searchForm.applyNumber = ''
            this.searchForm.pubNumber = ''
            this.searchForm.applyDate = ''
            this.searchForm.pubDate = ''
            this.searchForm.applicant = ''
            this.searchForm.inventor = ''
            this.searchForm.status = ''
            this.searchForm.type = ''
        },
        // 提交检索条件
        commitSearch(){
          // 判断检索条件，全部为空就提示
          if (!this.hasAtLeastOneField()) {
            this.$message.warning('请输入至少一个检索条件!');
            return false;
          }
          // 请求接口查询专利
          searchPatent(this.searchForm)
          .then(res=>{
            if(res.code == 200){
              this.patentData = res.data.results.map(item=>{
                return {
                    ...item,
                    checked: false  // 添加选中状态
                };
              })
              this.pageparm.currentPage = this.searchForm.page
              this.pageparm.pageSize = this.searchForm.ps
              this.pageparm.total = res.data.total
              this.searchNav = 'result'
            }else if(res.code == 201){
              this.$message({
                  type: 'warning',
                  message: '检索结果为空,请稍后再试!'
              })
            }else{
              this.$message({
                  type: 'warning',
                  message: res.msg
              })
            }
          })
        },
        // 判断表单是否至少有一个字段有值
        hasAtLeastOneField() {
           // 定义需要排除的字段
          const excludeFields = ['page', 'ps'];
          return Object.entries(this.searchForm).some(([key, value]) => {
            // 跳过排除的字段
            if (excludeFields.includes(key)) {
              return false;
            }
            // 处理字符串类型，去除空格后判断是否为空
            if (typeof value === 'string') {
              return value.trim() !== '';
            }
            // 处理其他类型（如数字、数组等）
            return value !== null && value !== undefined && value !== '';
          });
        },
        // 跳转专利检索
        jumpSearch(){
            this.searchNav = 'search'
        },
        handleCheckAllChange(val) {
          // 全选/全不选
          this.patentData.forEach(item => item.checked = val);
        },
        // 创建批量评估订单
        checkCreateEvalOrder(){
          // 判断是否选择
          let checkData = this.patentData.filter(item => item.checked);
          if(checkData.length <= 0){
            this.$message({
                  type: 'warning',
                  message: '请勾选需要评估的专利'
              })
            return false
          }
          // 查询是否存在已经评估过的专利
          let isPay = false;
          let pubNumberArr = [];
          checkData.map((o,i)=>{
            if(o.is_pay == true){
               this.$message({
                  type: 'warning',
                  message: '勾选中存在已评估过的专利!'
               })
               isPay = true
               return false
            }
            pubNumberArr.push(o.pubNumber[0])
          })
          if(isPay){
            return false
          }
          // 创建订单,计算总价
          this.getOrderConfigData()
          this.getUserInfoData()
          setTimeout(()=>{
              this.ordersConfirmVisible = true
              this.ordersForm.pay_type = ''
              this.ordersForm.is_use_points = ''
              this.ordersForm.total_fee = this.unitPrice * pubNumberArr.length
              this.ordersForm.documentNumbers = pubNumberArr
          },1500)

        },
        // 创建单件评估订单
        createEvalorder(val){
          this.getOrderConfigData()
          this.getUserInfoData()
          setTimeout(()=>{
              this.orderConfirmVisible = true
              this.orderForm.pay_type = ''
              this.orderForm.is_use_points = ''
              this.orderForm.total_fee = ''
              this.orderForm.documentNumber = val.pubNumber[0]
          },1500)
        },
        // 提交订单数据（单件评估）
        commitReportOrder(){
            this.orderForm.total_fee = this.unitPrice
            if(this.orderForm.pay_type == '' || this.orderForm.pay_type.length <= 0){
              this.$message({
                type: 'warning',
                message: '请选择支付方式!'
              })
              return false
            }
            createReportOrderByOne(this.orderForm)
            .then(res=>{
               if(res.code == 200){
                  // 判断是否积分全额抵扣
                  // 下单成功
                  this.$message({
                    type: 'success',
                    message: res.msg
                 })
                 this.orderResult = res.data
                 if(res.data.total_fee > 0){
                     // 支付金额大于0,显示支付二维码
                     this.codePayConfirmVisible = true
                 }else{
                     // 积分全额抵扣,显示积分支付确认页
                     this.pointsPayConfirmVisible = true
                 }
               }else{
                  this.$message.warning(res.msg);
               }
            })
            console.log(this.orderForm)
         },
         // 提交订单数据（批量评估）
         commitReportOrders(){
            if(this.ordersForm.pay_type == '' || this.ordersForm.pay_type.length <= 0){
              this.$message({
                type: 'warning',
                message: '请选择支付方式!'
              })
              return false
            }
            let param = {
              documentNumbers: JSON.stringify(this.ordersForm.documentNumbers),
              total_fee: this.ordersForm.total_fee,
              pay_type: this.ordersForm.pay_type,
              is_use_points: this.ordersForm.is_use_points
            }
            createReportOrderByMore(param)
            .then(res=>{
               if(res.code == 200){
                  // 判断是否积分全额抵扣
                  // 下单成功
                  this.$message({
                    type: 'success',
                    message: res.msg
                 })
                 this.orderResult = res.data
                 if(res.data.total_fee > 0){
                     // 支付金额大于0,显示支付二维码
                     this.codePayConfirmVisible = true
                 }else{
                     // 积分全额抵扣,显示积分支付确认页
                     this.pointsPayConfirmVisible = true
                 }
               }else{
                  this.$message.warning(res.msg);
               }
            })
            console.log(this.ordersForm)
         },
        // 获取订单配置数据
        getOrderConfigData(){
          getOrderConfig({})
          .then(res=>{
              if(res.code == 200){
                this.unitPrice = res.data.evaluate_fee
              }
          })
        },
        // 获取用户积分数据
        getUserInfoData(){
            getUserInfo({})
            .then(res=>{
               if(res.code == 200){
                  this.userPoints = res.data.points
               }
            })
         },
        // 积分支付订单
        orderPayUsePoints(){
          let order_sn = this.orderResult.order_sn
          if(order_sn.length <= 0){
              this.$message({
                type: 'warning',
                message: '订单号不存在!'
              })
              return false
          }
          let param = { order_sn }
          orderPayByPoints(param)
          .then(res=>{
              if(res.code == 200){
                this.$message({
                    type: 'success',
                    message: res.msg
                })
                this.pointsPayConfirmVisible = false
                this.orderConfirmVisible = false
                this.ordersConfirmVisible = false
                // 跳转评估记录
                // setTimeout(()=>{
                //    this.$router.push({ path: '/customer/evalRecord'});
                // },1000)
              }else{
                this.$message({
                    type: 'error',
                    message: res.msg
                })
              }
          })
        },
        // 查询订单详情
        getOrderInfoData(){
            let order_sn = this.orderResult.order_sn
            if(order_sn.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '订单号不存在!'
               })
               return false
            }
            let param = { order_sn }
            getEvalOrderInfo(param)
            .then(res=>{
               if(res.code == 200){
                  if(res.data.status == 2){
                     // 支付成功,跳转评估记录
                     this.$message({
                        type: 'success',
                        message: '支付成功!'
                     })
                     this.codePayConfirmVisible = false
                     this.orderConfirmVisible = false
                     this.ordersConfirmVisible = false
                     this.stopTimer()
                     // 跳转评估记录
                    //  setTimeout(()=>{
                    //     this.$router.push({ path: '/customer/evalRecord'});
                    //  },1000)
                  }
               }
            })
         },
         // 开始执行定时器
         startTimer(){
            this.intervalId = setInterval(()=>{
               this.getOrderInfoData()
            },2000);
         },
         // 结束定时器
         stopTimer(){
            if(this.intervalId){
               clearInterval(this.intervalId);
               this.intervalId = null;
            }
         },
        // 查看报告
        viewReport(row){
         console.log(row)
         let url = row.report_url
         window.open(url)
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
            this.searchPatent()
        },

      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 20px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-form {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-form>>>.el-form-item__label {
   /* text-align: left !important; */
   font-weight: 700 !important;
   padding-left: 10px !important;
  }
  .my_card>>>.el-input__inner {
    background-color: #f2f6f9;
    padding-right: 90px !important;
    height: 40px;
  }
  .my_btnBox {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    height: 80px;
  }
  .my_btnBox .btn {
    font-size: 18px;
    color: #9295a2;
    background-color: #fff;
    padding: 14px 60px;
    border: 1px solid #9295a2;
    border-radius: 100px;
    cursor: pointer;
  }
  .my_btnBox .cat {
    color: #ffffff;
    background-color: #2A91DD;
    border: 1px solid #2A91DD;
  }
  .search_page {
    height: 460px;
    padding: 30px 30px 30px;
  }
  .result_page {
    height: 580px;
    padding: 0px 30px;
  }
  .headTab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #eeeeee;
    margin: 0px 10px;
    padding: 4px 0px;
  }
  .headTab .number {
    font-size: 14px;
    margin-left: 30px;
  }
  .number span {
    color: #2A91DD;
  }
  .result_list {
    padding: 10px 0px;
    height: 450px;
    overflow-y: scroll;
    margin: 10px 10px;
  }
  .result_card {
    padding: 12px 20px;
    margin: 10px 30px;
  }
  .result_card .card_div {
    display: flex;
    margin-top: 2px;
    font-size: 12px;
  }
  .result_card .card_text {
    width: 25%;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .result_card .card_text span {
    color: #9295a2;
  }
  .bgFFFFFF {
    background-color: #ffffff;
  }
  .bgF3F9FC {
    background-color: #F3F9FC;
  }
  .pat_type {
    font-size: 12px;
    background-color: #E58F39;
    color: #FFFFFF;
    margin-top: 2px;
    padding: 0px 6px;
    line-height: 20px;
  }
  .eval_btn {
    margin-left: 20px;
    font-size: 12px;
    background-color: #2A91DD;
    color: #ffffff;
    line-height: 20px;
    padding: 0px 6px;
    height: 20px;
    margin-top: 2px;
    cursor: pointer;
  }
  .pay_order_th {
   display: flex;
   align-items: center;
   padding: 0 20px;
   background: #efefef;
   border-radius: 4px;
   font-size: 14px;
   color: #333;
   height: 32px;
 }
 .pay_order {
   padding: 20px;
   width: 690px;
   background: #fff;
   box-shadow: 0 5px 10px #cec7e0a8;
   border-radius: 10px;
 }
 .pay_order_tr {
   display: flex;
   align-items: center;
   padding: 0 20px;
   font-size: 14px;
   color: #333;
   height: 47px;
   border-bottom: 1px solid #efefef;
 }
 .order_count {
   border-top: 1px solid #bdbdbd;
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 10px 20px;
 }
  .pay_title {
   display: flex;
   font-size: 16px;
   margin-top: 30px;
   margin-bottom: 20px;
   color: #333;
 }
 .pay_title_bg {
   width: 10px;
   height: 23px;
   background-color: #2A91DD;
   border-radius: 4px;
   margin-right: 13px;
 }
 .pay_type_box {
   padding: 24px 20px;
   width: 690px;
   background: #fff;
   box-shadow: 0 5px 10px #cec7e0a8;
   border-radius: 10px;
   display: flex;
   align-items: center;
 }
 .pay_type_item {
   display: flex;
    width: 187px;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #eee;
    margin-right: 20px;
 }
 .pay_type_jf {
   flex: 1;
   height: 50px;
   line-height: 50px;
   text-align: center;
   font-size: 14px;
   color: #333;
 }
 .pay_btn {
   margin-top: 30px;
   display: flex;
   justify-content: flex-end;
 }
 .pay_price {
   display: flex;
   flex-direction: column;
   align-items: center;
   padding-top: 30px;
   height: 400px;
 }
</style>


// WEBPACK FOOTER //
// src/views/client/patentSearch.vue